export default __webpack_public_path__ + "static/media/lion.e1de6ae1.png";